import { applyMiddleware, compose, createStore } from 'redux';
import { createBrowserHistory } from 'history';

import { routerMiddleware } from 'react-router-redux';
import promise from 'redux-promise-middleware';
import thunkMiddleware from 'redux-thunk';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';

import rootReducer from 'reducers';
import settings from 'settings';
import loadState from './initialState';

export const history = createBrowserHistory({
  basename: settings.BASE_URI()
});

const configureStore = () => {
  // Initial State of the Reducers.
  const initialState = loadState();

  const middlewares = [
    routerMiddleware(history),
    thunkMiddleware,
    promise
  ];

  if (settings.VERSION === 'LOCAL') {
    middlewares.push(reduxImmutableStateInvariant()); // Has major performance issues, and isn't needed for prod
  }

  // Add redux develp tool support
  // eslint-disable-next-line no-underscore-dangle
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  return createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middlewares)));
};

export default configureStore;
